// @flow

import styled, { css } from "styled-components";
import { fontCondensed, fontNormal, fontBold } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";
import ButtonDefault from "../../_atoms/ButtonDefault";

export const PastPerformanceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px 12px 0;
  line-height: 125%;

  & > span:first-child {
    width: 56px;
  }
`;

export const RaceNumber = styled.span`
  white-space: nowrap;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-size: 10px;
  font-family: ${fontCondensed};
  text-transform: uppercase;
  color: ${buildColor("grey", "D3")};
  ${({ isResult }) =>
    !isResult &&
    css`
      border-right: 1px solid ${buildColor("grey", "300")};
    `};
  ${({ isEmpty }) =>
    isEmpty &&
    css`
      &::after {
        content: ".";
        position: absolute;
        bottom: -12px;
        left: 0;
        right: 0;
      }
    `}

  & > span:last-child {
    letter-spacing: 1px;
  }
`;

export const Number = styled.span`
  display: flex;
  font-size: 12px;
  position: relative;
  text-transform: none;
  font-family: ${({ isPodium }) => (isPodium ? fontBold : fontNormal)};
  color: ${({ isPodium }) =>
    isPodium ? buildColor("green") : buildColor("grey", "D4")};
  ${({ isEmpty }) =>
    isEmpty &&
    css`
      &::after {
        content: ".";
        position: absolute;
        top: -16px;
        left: 0;
        right: 0;
      }
    `}

  ${({ isPodium }) =>
    isPodium &&
    css`
      & > span {
        transform: translateY(1px);
      }
    `}
`;

export const ShowMore = styled(ButtonDefault)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 125%;
`;

export const MoreTag = styled.span`
  color: ${buildColor("blue")};
  font-family: ${fontNormal};
  font-size: 12px;
`;
